import { formatDistanceToNow } from 'date-fns';
export const formatTimestamp = (timestamp: string): string => {
  try {
    // Handle various timestamp formats
    if (timestamp === 'Just now' || timestamp.includes('just now')) {
      return 'Just now';
    }
    
    if (timestamp.includes('day')) {
      return timestamp; // Return as is for "X day(s)" format
    }
    
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return timestamp; // Return original if invalid date
    }
    
    const now = new Date();
    const diffInMinutes = Math.abs(now.getTime() - date.getTime()) / (1000 * 60);
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${Math.floor(diffInMinutes)}m ago`;
    
    const diffInHours = diffInMinutes / 60;
    if (diffInHours < 24) return `${Math.floor(diffInHours)}h ago`;
    
    const diffInDays = diffInHours / 24;
    if (diffInDays < 7) return `${Math.floor(diffInDays)}d ago`;
    
    // Format as date for older timestamps
    return date.toLocaleDateString();
  } catch (error) {
    return timestamp;
  }
};
export const formatTimestamp2 = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.error("Invalid timestamp", error);
    return timestamp;
  }
};

export const truncateText = (text: string, maxLength: number): { truncated: string; isTruncated: boolean } => {
  if (text.length <= maxLength) {
    return { truncated: text, isTruncated: false };
  }
  
  return {
    truncated: text.substring(0, maxLength),
    isTruncated: true
  };
};

export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .slice(0, 2)
    .join('')
    .toUpperCase();
}; 